import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import { GetPaymentReportApi } from "../../../api/request/reports/report.js";
import SkeletonTable from "../../../components/table/SkeletonTable.jsx";
import columns from "../../../columns/reports/paymentReport.js";
import { Tag } from "antd";

const Payment = () => {
  const [paymentReport, setPaymentReportList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalPending, setTotalPending] = useState(0);

  const getPaymentReportList = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetPaymentReportApi();
      if (data?.status) {
        let amount = 0;
        let pending = 0;
        setPaymentReportList(
          data?.data?.map((item) => {
            if (item?.status == "APPROVED") {
              amount += parseFloat(item?.amount);
            } else {
              pending += parseFloat(item?.amount);
            }
            return {
              ...item,
              organizer: (
                <div className="font-bold highlight-text capitalize">
                  {item?.organizer?.organizer_name_slug}
                </div>
              ),
              // name: item?.users?.name,
              name: (
                <div className="flex gap-2 items-center">
                  <p>{item?.users?.name}</p>
                  {
                    item?.is_extra_invoice && (
                      <Tag color="red" className="mt-1">
                        External
                      </Tag>
                    )
                  }
                </div>
              ),
              email: item?.users?.email,
              amount: item?.amount,
              invoice: (item?.organizer?.invoice_pdf || item?.invoice_path) ? (
                <a
                  href={item?.organizer?.invoice_pdf || item?.invoice_path}
                  className="text-primary"
                  target="_blank"
                >
                  Check Invoice
                </a>
              ) : (
                "--"
              ),
              startDate: item?.created_at
                ? moment(item?.created_at).format("lll")
                : "",
              statusText: (
                <p
                  className={`font-bold uppercase ${item?.status == "PENDING"
                    ? "text-red-600"
                    : "text-green-500"
                    }`}
                >
                  {item?.status}
                </p>
              ),
            };
          })
        );
        setTotalAmount(amount);
        setTotalPending(pending);
      }
      setIsLoading(false);
    } catch (error) {
      setPaymentReportList([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPaymentReportList();
  }, []);

  return (
    <div className="border-2 rounded-xl my-5">
      <div className="flex justify-between mx-5 mt-5">
        <p className=" font-semibold text-2xl">Payment Reports</p>
        <p className="font-semibold text-lg">
          Total Recieved (${totalAmount}) &nbsp; Total Pending (${totalPending})
        </p>
      </div>
      <div className="my-6">
        <SkeletonTable
          searchingFields={["name", "email"]}
          dateFilterFields={["startDate"]}
          columns={columns}
          data={paymentReport}
          isLoading={isLoading}
          pagination={true}
        />
      </div>
    </div>
  );
};

export default Payment;
